import images from './assets/images';

export const FEEDBUCKET_ID = 'ymoY6WCJnRO2e3B5MaUA';

export const PART_BKG_COLOR = '#f76808';
export const NON_PART_BKG_COLOR = '#4e52c1';

export const PART_TYPES = {
    NON_PART: 0,
    PART: 1,
    DRAWING: 2,
    REMNANT: 3,
    LAYOUT: 4,
    SINK: 5
};

export const KEYBOARD = {
    TAB: 9,
    ENTER: 13,
};

export const INTEGRATION_TYPES = {
    1: { label: 'Moraware', logo: images.icons.Moraware },
    // 2: 'Moraware (Self Hosted)', // they probably don't need the "Self Hosted" label
    2: { label: 'Moraware', logo: images.icons.Moraware },
    3: { label: 'Eased Edge', logo: images.icons.EasedEdge },
    4: { label: 'Action Flow' },
    5: { label: 'SPEEDfolder', logo: images.icons.SPEEDfolder },
    6: { label: 'Stone App' }
};

export const DATA_SOURCE_MAP = {
    MORAWARE: 'moraware',
    EASED_EDGE: 'eased',
    ACTION_FLOW: 'action',
};

export const DATA_SOURCE_OPTIONS = [
    { value: DATA_SOURCE_MAP.EASED_EDGE, label: 'Eased Edge' },
    { value: DATA_SOURCE_MAP.MORAWARE, label: 'Moraware' },
    { value: DATA_SOURCE_MAP.ACTION_FLOW, label: 'Action Flow' },
];

export const DATA_SOURCE_DEFAULT = DATA_SOURCE_MAP.MORAWARE;

export const TEMPLATE_FIELD_TYPE = {
    TEXT: { value: 'txt', label: 'Text' },
    BARCODE: { value: 'bc', label: 'Barcode' },
    QR: { value: 'qr', label: 'QR Code' },
    IMG: { value: 'img', label: 'Image' },
    DATE: { value: 'date', label: 'Date' },
    DATE_TIME: { value: 'date-time', label: 'Date & Time' }
};

export const TEMPLATE_FIELD_TYPES = [
    TEMPLATE_FIELD_TYPE.TEXT,
    TEMPLATE_FIELD_TYPE.DATE,
    TEMPLATE_FIELD_TYPE.DATE_TIME,
    TEMPLATE_FIELD_TYPE.QR,
    TEMPLATE_FIELD_TYPE.BARCODE,
    TEMPLATE_FIELD_TYPE.IMG,
];

export const LABEL_SIZE_MAP = {
    DEFAULT: '4x8',
    _4x8: '4x8',
    _4x6: '4x6',
    _4x3: '4x3',
    _4x1: '4x1',
    REMNANT: 'REMNANT'
};

export const LABEL_SIZE_OPTIONS = [
    {
        value: LABEL_SIZE_MAP._4x8,
        label: '4x8'
    },
    {
        value: LABEL_SIZE_MAP._4x6,
        label: '4x6'
    },
    {
        value: LABEL_SIZE_MAP._4x3,
        label: '4x3'
    },
    {
        value: LABEL_SIZE_MAP._4x1,
        label: '4x1'
    }
];

export const IS_BAD_CHROME = false;
// export const IS_BAD_CHROME = Boolean(navigator.userAgentData?.brands.find(({ brand, version }) => brand === 'Chromium' && parseFloat(version, 10) >= 105));
// if (IS_BAD_CHROME) {
//     LABEL_SIZE_OPTIONS.splice(2, 1);
// }

export const PREVIEW = {
    CHECKLIST: { 'logo': images.logos.SPEEDlabel, 'items': ['Circle measurements', 'Inspect edge profile and layer colors', 'Feel bottom of edge', 'Clean surface and inspect for scratches', 'Sign name on label'] },
    COLORS: [{ label: 'Monday', style: { backgroundColor: 'red', color: 'white' } }]
};

export const FEATURES = {
    // controls whether to show the SPEEDlink QR code on evert 4x3 and 4x6 labels
    QR_PART_IMAGES: 'speedlabel_label_qr_code', // 👈 feature flag in post hog
    REMNANT_LABELS: 'speedlabel_remnant_labels',
    JOB_SHEET: 'speedlabel_job_sheet'
};

export const CACHE_KEY = {
    TEMPLATE_SELECTION: 'TEMPLATE_SELECTION',
    CHECKLIST_SELECTION: 'CHECKLIST_SELECTION',
    COLOR_SELECTION: 'COLOR_SELECTION',
    SPEEDSNIP_JOB_ID: 'SPEEDSNIP_JOB_ID',
    SPEEDLABEL_JOB_ID: 'SPEEDLABEL_JOB_ID',
    QR_CODE_LABELS_DISABLED: 'QR_CODE_LABELS_DISABLED',
    QR_CODE_HINT_DISABLED: 'QR_CODE_HINT_DISABLED',
    REMNANTS_DISABLED: 'REMNANTS_DISABLED',
    LABEL_SIZE: 'LABEL_SIZE',
    SPOTLIGHT_COMPLETED: 'SPOTLIGHT_COMPLETED',
    JOB_SHEET_CHECKLIST: 'JOB_SHEET_CHECKLIST',
    JOB_SHEET_OPTIONS: 'JOB_SHEET_OPTIONS'
};

export const POSTHOG_KEY = 'phc_w3UYefmTQoomrpmjV8wnE3nP0bWAckGMwE7qD35PMuw';

let _ENVIRONMENT = 'development';
// API
let _SPEEDLABEL_WEB_API_BASE = 'http://localhost:8081';
let _AUTH_WEB_API_BASE = 'http://localhost:7777';
// APP
let _DASHBOARD_WEB_APP = 'http://localhost:3004/app/dashboard';
let _SPEEDFOLDER_WEB_APP = 'http://localhost:3002/app/dashboard';
let _FGT_REDIRECT_BASE = 'http://localhost:8081/api/public/speed_link/r';

(() => {
    switch (window.location.hostname) {
        case 'www.staging.fifthgeartech.com':
            _ENVIRONMENT = 'staging';
            // API
            _SPEEDLABEL_WEB_API_BASE = 'https://speedlabel-web-api.staging.fifthgeartech.com';
            _AUTH_WEB_API_BASE = 'https://auth-web-api.staging.fifthgeartech.com';
            // APP
            _DASHBOARD_WEB_APP = 'https://staging.fifthgeartech.com/app/dashboard';
            _SPEEDFOLDER_WEB_APP = 'https://staging.fifthgeartech.com/app/speedfolder';
            _FGT_REDIRECT_BASE = 'https://s.5gt.us';
            break;
        case 'www.fifthgeartech.com':
            _ENVIRONMENT = 'production';
            // API
            _SPEEDLABEL_WEB_API_BASE = 'https://speedlabel-web-api.fifthgeartech.com';
            _SPEEDFOLDER_WEB_APP = 'https://fifthgeartech.com/app/speedfolder';
            _AUTH_WEB_API_BASE = 'https://auth-web-api.fifthgeartech.com';
            // APP
            _DASHBOARD_WEB_APP = 'https://fifthgeartech.com/app/dashboard';
            _FGT_REDIRECT_BASE = 'https://5gt.us';
            break;
        default:
            break;
    }
})();

export const ENVIRONMENT = _ENVIRONMENT;
// API
export const SPEEDLABEL_WEB_API_BASE = _SPEEDLABEL_WEB_API_BASE;
export const AUTH_WEB_API_BASE = _AUTH_WEB_API_BASE;
// APP
export const DASHBOARD_WEB_APP = _DASHBOARD_WEB_APP;
export const SPEEDFOLDER_WEB_APP = _SPEEDFOLDER_WEB_APP;
export const FGT_REDIRECT_BASE = _FGT_REDIRECT_BASE;